const Territory = require('../../entities/Territory');
const { Age }  = require("../Constants");
const TerritoryNames = require("../Names/TerritoryNames");

class InhabitedTerritory extends Territory {
    constructor(age){
        super(
            age,
            TerritoryNames.InhabitedTerritory,
            "Gain " + InhabitedTerritory.GetYellowCubeCount(age) + " yellow cubes and increase population " + InhabitedTerritory.GetPopIncreaseCount(age) + " time(s)",
            {}
        )
    }

    static GetYellowCubeCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 2;
            case Age.Age2:
                return 3;
        }
    }

    static GetPopIncreaseCount(age)
    {
        switch (age)
        {
            default:
                return null;
            case Age.Age1:
                return 1;
            case Age.Age2:
                return 2;
        }
    }
}

module.exports = InhabitedTerritory;